import { PDFDocument } from 'pdf-lib';

// Fills the live static contract template (/assets/contract/Contract.pdf) —
// this is the actual document customers sign via ContractBuilderPage, and the
// one CustomerHubPage's Documents section previews. Kept separate from
// src/services/contract-pdf.js, which draws an alternate contract from
// scratch with jsPDF and is not currently wired into any page.
function fmtMoney(v) {
  const n = parseFloat(v);
  if (isNaN(n)) return v || '';
  return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export async function fillContractPDF(fields, repSigDataUrl, customerSigDataUrl) {
  const response = await fetch('/assets/contract/Contract.pdf');
  const pdfBytes = await response.arrayBuffer();
  const pdfDoc   = await PDFDocument.load(pdfBytes, { ignoreEncryption: true });
  const form     = pdfDoc.getForm();

  function setTextField(name, value) {
    try { form.getTextField(name).setText(value || ''); } catch(e) { /* skip */ }
  }
  function setDropdown(name, value) {
    try {
      const f = form.getDropdown(name);
      if (value && f.getOptions().includes(value)) f.select(value);
    } catch(e) { /* skip */ }
  }
  function setCheckbox(name, checked) {
    try {
      const f = form.getCheckBox(name);
      if (checked) f.check(); else f.uncheck();
    } catch(e) { /* skip */ }
  }

  setTextField('contract number',                       fields.contractNumber);
  setTextField('Purchaser',                             fields.purchaserName);
  setTextField('Address',                               fields.address);
  setTextField('CitystZip 1',                           fields.cityStateZip);
  setTextField('Email',                                 fields.email);
  setTextField('Home Phone',                            fields.homePhone);
  setTextField('Cell Phone',                            fields.cellPhone);
  setTextField('Work Phone',                            fields.workPhone);
  setTextField('Fax Number',                            fields.faxNumber);
  setTextField('Project Description',                   fields.projectDescription);
  setTextField('alumn wrap Color',                      fields.wrapColor);
  setTextField('1 Cash Price including sales tax',      fmtMoney(fields.cashPrice));
  setTextField('2 Cash Down Payment',                   fmtMoney(fields.downPayment));
  setTextField('3 UNPAID BALANCE  DUE UPON COMPLETION', fmtMoney(fields.unpaidBalance));
  setTextField('date',                                  fields.sigDay);
  setTextField('20',                                    fields.sigYear);

  setDropdown('trash',                  fields.trash);
  setDropdown('apprx installtion date', fields.installMonth);
  setDropdown('month of signing',       fields.sigMonth);

  setCheckbox('Low E argon gas', fields.cbLowE);
  setCheckbox('gas',             fields.cbScreen);
  setCheckbox('outside trim',    fields.cbOutsideTrim);
  setCheckbox('brickmold',       fields.cbBrickmold);
  setCheckbox('1x4',             fields.cbOneByFour);

  if (repSigDataUrl) {
    try {
      const base64   = repSigDataUrl.split(',')[1];
      const sigBytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
      const sigImage = await pdfDoc.embedPng(sigBytes);
      const sigField = form.getField('Represenative signature');
      const widgets  = sigField.acroField.getWidgets();
      if (widgets.length > 0) {
        const rect = widgets[0].getRectangle();
        pdfDoc.getPage(0).drawImage(sigImage, { x: rect.x, y: rect.y, width: rect.width, height: rect.height });
      }
    } catch(e) { console.warn('Rep sig:', e.message); }
  }

  if (customerSigDataUrl) {
    try {
      const base64   = customerSigDataUrl.split(',')[1];
      const sigBytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
      const sigImage = await pdfDoc.embedPng(sigBytes);
      let placed = false;
      for (const name of ['Purchaser signature', 'purchaser signature', 'Purchaser Signature', 'PURCHASER']) {
        try {
          const sigField = form.getField(name);
          const widgets  = sigField.acroField.getWidgets();
          if (widgets.length > 0) {
            const rect = widgets[0].getRectangle();
            pdfDoc.getPage(0).drawImage(sigImage, { x: rect.x, y: rect.y, width: rect.width, height: rect.height });
            placed = true;
            break;
          }
        } catch(e) { /* try next */ }
      }
      if (!placed) {
        pdfDoc.getPage(0).drawImage(sigImage, { x: 52, y: 58, width: 200, height: 40 });
      }
    } catch(e) { console.warn('Customer sig:', e.message); }
  }

  form.flatten();
  return await pdfDoc.save();
}

export function buildFieldsFromContract(contract) {
  const cust = contract.customer || {};
  const cx   = contract.checkboxes || {};
  return {
    contractNumber:     contract.contractNumber || '',
    purchaserName:      cust.name || '',
    address:            cust.address || '',
    cityStateZip:       cust.cityStateZip || cust.city || '',
    email:              cust.email || '',
    homePhone:          cust.homePhone || cust.phone || '',
    cellPhone:          cust.cellPhone || cust.cell || '',
    workPhone:          cust.workPhone || '',
    faxNumber:          cust.faxNumber || '',
    projectDescription: contract.projectDescription || '',
    installMonth:       contract.installMonth || contract.installDate || '',
    wrapColor:          contract.wrapColor || contract.aluminumWrapColor || '',
    trash:              contract.trash || '',
    cashPrice:          contract.cashPrice || '',
    downPayment:        contract.downPayment || '',
    unpaidBalance:      contract.unpaidBalance || '',
    sigDay:             contract.sigDay || '',
    sigMonth:           contract.sigMonth || '',
    sigYear:            contract.sigYear || '',
    cbLowE:             cx.lowE || cx.lowEArgonGas || false,
    cbScreen:           cx.screen || false,
    cbOutsideTrim:      cx.outsideTrim || false,
    cbBrickmold:        cx.brickmold || false,
    cbOneByFour:        cx.oneByFour || false,
  };
}
